import React from 'react';
import {useSelector} from "react-redux";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import BBDataTable from "../tables/BBDataTable";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import BRSocialIdentitiesDetailsModal from "./BRSocialIdentitiesDetailsModal";
import IdentityScopeToggle from "./IdentityScopeToggle";
import GpsFixedSharpIcon from "@material-ui/icons/GpsFixedSharp";
import NewBRProvidingElementDialog from "../BreachRiskValidationProviding/NewBRProvidingElementDialog";
import NewBRIdentityProvidedForm from "../BreachRiskValidationProviding/NewBRIdentityProvidedForm";

const BRSocialIdentitiesTable = ({
                                    portfolioView=false,
                                 })=>{

    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const isAdmin = isCurrentUserMemberOf(authUser, "admin");

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    // const userHasAccess = (isAdmin || myEntity.pro_subscription || myEntity.premium_subscription)
    const entityHasSocialOn = myEntity && myEntity.settings && myEntity.settings.social_testing_authorized;
    const userHasPremiumAccess = myEntity && myEntity.premium_subscription;

    const lastCycle = myEntity ? myEntity.last_cycle : null;
    const lastCycleId = myEntity && myEntity.settings && myEntity.settings.last_cycle_id;

    const social = myEntity
        && myEntity.cycles
        && lastCycleId
        && myEntity.cycles[lastCycleId]
        && !loadingCycleSocial[lastCycleId]
        && myEntity.cycles[lastCycleId].social;

    const numIdentities = social
        && social.cycleTotals
        && social.cycleTotals.number_identities
    ? social.cycleTotals.number_identities
        : 0;

    const incompleteSocialCall = !userHasPremiumAccess || !entityHasSocialOn

   /* const numIdentities = social
    && social.cycleTotals
        && social.cycleTotals.number_identities
    && social.cycleTotals.pages
    && social.cycleTotals.pages > 1
        && entityHasSocialOn
        //if social is on and other data is there, set num identites equal to the one provided by api
        ?  social.cycleTotals.number_identities
        //else ran this other check for data being there
        : social
        && social.cycleTotals
        && social.cycleTotals.page_size
            && social.cycleTotals.number_identities
            //compare page size and number ids and if number of ids are less, set equal to that (So less than 25)
            && social.cycleTotals.page_size > social.cycleTotals.number_identities
    ? social.cycleTotals.number_identities
            //else run check again and set as page size
    : social
            && social.cycleTotals
            && social.cycleTotals.page_size
    ? social.cycleTotals.page_size
                //and finally null in case I've messed up or none of those are corect
                :null;*/
console.log("portfolioVIew", portfolioView, "numIdentities", numIdentities, )

    const identitiesArray = myEntity
        && myEntity.cycles
        && myEntity.cycles[lastCycle.cycle]
        && myEntity.cycles[lastCycle.cycle].social
        && myEntity.cycles[lastCycle.cycle].social.identities
        && Object.keys(myEntity.cycles[lastCycle.cycle].social.identities)

    const identities = identitiesArray ? identitiesArray.map((id)=>{

        const identity = myEntity.cycles[lastCycle.cycle].social.identities[id]

        const identityTags = identity && identity.tags && Object.values(identity.tags).filter((tag)=> tag.is_active)

        const isOutOfScope = identityTags && Array.isArray(identityTags) && identityTags.length > 0;

        const outOfScopeTag = isOutOfScope
            ? identityTags
                .sort((a,b)=> b.added_datetime - a.added_datetime)
                .slice(0, 1)
                .shift()
            : null;

        return{
            id: id,
            hasScopeTag: isOutOfScope ? "Out of Scope" : "In Scope",
            ...myEntity.cycles[lastCycle.cycle].social.identities[id]
        }
    }) : [];


    const title = <div className={""} id={"tourSocialIdentitiesTable"}>
        Active Identities <Tooltip title={"Details for the human identities and/or usernames we've found within the organization."}>
        <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
    </Tooltip>
    </div>;

    const description = <>Active identities are people and/or accounts. Attackers can attempt to manipulate people or use accounts to attempt to authenticate with your systems.
        These can be discovered through many open source and publicly-detectable means. Over time, identities that appear to be invalid or inactive are removed from this list.
        The identities shown below include those we've discovered in a previous scoring cycle. Identities that you've added using the Verifications feature will appear at the conclusion of the next scoring cycle.</>


    const userTableHeadings = [
        { field: 'id', headerName: 'ID', hide: true, flex : 1, sortable: true, type: 'string', renderCell: (params) => {
                return params.value}},
        { field: 'first', headerName: 'First', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (<Tooltip title={``}>
                    <span>
                        {params.value ? params.value : "--"}
                    </span>
                </Tooltip>))},
        { field: 'last', headerName: 'Last', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        {params.value ? params.value : "---"}
                    </span>
                </Tooltip>))},
        { field: 'email', headerName: 'Email', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        {params.value ? params.value : "---"}
                    </span>
                </Tooltip>))},
        { field: 'position', headerName: 'Position', hide: false, flex : 1, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <Tooltip title={``}>
                    <span>
                        {params.value ? params.value : "---"}
                    </span>
                </Tooltip>))},
        { field: 'provided', headerName: 'Provided', hide: false, sortable: true, type: 'boolean', width: 110, renderCell: (params) =>
                renderCellExpand(params, (<>
                        {params.value
                            ? <Tooltip title={`Your company provided this element.`}>
                                  <span className={"text-center"}>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                            </Tooltip>
                            : <Tooltip title={`This element was discovered by BreachBits.`}>
                                  <span className={"text-center"}>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                        }
                    </>

                ))},
        { field: 'viewMore', headerName: 'View More', hide: false, width:110, sortable: false, type: 'string', disableExport: true, filterable: false,
            renderCell: (params) =>
                renderCellExpand(params, (
                    <BRSocialIdentitiesDetailsModal identityId={params.row.id}/>))},
        { field: 'hasScopeTag', headerName: 'Scope', cellClassName: "tourSetScopeCol",
            renderHeader: params =>
                <Tooltip title={"Scope | Select the icon to toggle an Identity In Scope or Out of Scope. Identities Out of Scope will not be tested, "+
                "Identities In Scope will be tested if you have Social Engineering enabled."}>
                  <span id={"tourSetScope"}>
                      <GpsFixedSharpIcon/>
                  </span>
                </Tooltip>, hide: false, width:60, sortable: true, type: 'string', renderCell: (params) =>
                renderCellExpand(params, (
                    <span className={"m-0 p-0 text-center"}>
                        <IdentityScopeToggle identityId={params.row.id}/>
                    </span>)

                )
        },
    ];


    return(
        <div>
            {
                (identitiesArray || numIdentities === 0 || identitiesArray.length === 0)
            // && myEntity
            // && myEntity.cycles
            // && myEntity.cycles[lastCycle.cycle]
            //     && !loadingCycleSocial[lastCycle.cycle]
            // && myEntity.cycles[lastCycle.cycle].social
                ?
                <BBDataTable
                    columns={userTableHeadings}
                    rows={identities}
                    totalRows={numIdentities}
                    title={title}
                    description={description}
                    // loading = { incompleteSocialCall ? false : identitiesArray && identitiesArray.length === numIdentities ? false : true}
                    progressValue={numIdentities === 0 || incompleteSocialCall ? 100 : identitiesArray.length / numIdentities * 100}
                    bufferValue={numIdentities === 0 || incompleteSocialCall ? 100 : identitiesArray.length / numIdentities * 100 + 25}
                    enableExport
                    topRightElement={
                        <NewBRProvidingElementDialog
                            formComponent={<NewBRIdentityProvidedForm entityId={entityInView}/>}
                            buttonLabel={"Identity"}
                        />
                    }
                    // lite={(portfolioView && !isTrustedAgentForThisEntity) || true}
                    lite={!portfolioView}
                    portfolioStarter={!isTrustedAgentForThisEntity}
                    portfolioView={portfolioView}
                />
                :
                <BBDataTable
                    columns={userTableHeadings}
                    rows={[]}
                    title={title}
                    loading = {true}
                    progressValue={0}
                    bufferValue={15}
                    description={description}
                    lite={(portfolioView && !isTrustedAgentForThisEntity) || true}
                    portfolioStarter={!isTrustedAgentForThisEntity}
                    portfolioView={portfolioView}
                />
            }
        </div>
    )
}

export default BRSocialIdentitiesTable;